import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfiguracoesRoutingModule } from './configuracoes-routing.module';
import { ConfiguracoesComponent } from './configuracoes.component';
import { ConfiguracoesParametrosComponent } from './configuracoes-parametros/configuracoes-parametros.component';
import { SharedModule } from '../../shared/shared.module';
import { ConfiguracoesEmailComponent } from './configuracoes-email/configuracoes-email.component';
import { CardConfiguracoesComponent } from './card-configuracoes/card-configuracoes.component';
import { ModalParametrosComponent } from './configuracoes-parametros/modal-parametros/modal-parametros.component';
import { ConfiguracoesRepasseComponent } from './configuracoes-repasse/configuracoes-repasse.component';
import { HeaderRepasseComponent } from './configuracoes-repasse/header-repasse/header-repasse.component';
import { ListagemRepasseComponent } from './configuracoes-repasse/listagem-repasse/listagem-repasse.component';
import { ModalAddEmailComponent } from './configuracoes-email/modal-add-email/modal-add-email.component';
import { ConfiguracoesLojaComponent } from './configuracoes-loja/configuracoes-loja.component';
import { ModalLojaComponent } from './configuracoes-loja/modal-loja/modal-loja.component';
import { ConfiguracoesEstornoComponent } from './configuracoes-estorno/configuracoes-estorno.component';
import { ModalEstornoComponent } from './configuracoes-estorno/modal-estorno/modal-estorno.component';
@NgModule({
  declarations: [
    ConfiguracoesComponent,
    ConfiguracoesParametrosComponent,
    ConfiguracoesEmailComponent,
    CardConfiguracoesComponent,
    ModalParametrosComponent,
    ConfiguracoesRepasseComponent,
    HeaderRepasseComponent,
    ListagemRepasseComponent,
    ModalAddEmailComponent,
    ConfiguracoesLojaComponent,
    ModalLojaComponent,
    ConfiguracoesEstornoComponent,
    ModalEstornoComponent
  ],
  imports: [CommonModule, ConfiguracoesRoutingModule, SharedModule],
  exports: [ConfiguracoesComponent]
})
export class ConfiguracoesModule {}
